// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"784e3341","466":"0302feb5","738":"f558b4ab","856":"0c475880"}[chunkId] + ".chunk.js";
};